module.exports = __webpack_public_path__ + "img/arrowBack.dfe39ef0.svg";